/* eslint-disable */
import listing from "../apollo/b2b_wl/listing.gql";

export const state = () => ({ listing: [], loading: false });

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 17 Mar 2025 | 12:21PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.listing = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 17 Mar 2025 | 12:21PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 17 Mar 2025 | 12:21PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.fetch_b2b_wl_users);
          resolve(data.fetch_b2b_wl_users);
          commit("setLoading", false);
        })
        .catch((err) => commit("setLoading", false));
    });
  }
};

export const getters = {
  listing: (state) => state.listing,
  loading: (state) => state.loading
};
